// extracted by mini-css-extract-plugin
module.exports = {"dataViewer":"EntityDataViewer_dataViewer__3McRU","entry":"EntityDataViewer_entry__2vhg9"};